import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import Image from "next/image";
import cloudl1Tab from "@/Helper/images/certified_experts.png";
import cloudl2Tab from "@/Helper/images/end_to_end_support.png";
import cloudl3Tab from "@/Helper/images/tailored_solutions.png";
import cloudl4Tab from "@/Helper/images/enhanced_security_compliance.png";
import cloudl5Tab from "@/Helper/images/continuous_innovation.png";


export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Unified Cloud Excellence",
    "Scalable, Cost-Efficient Solutions",
    "Lightning-Fast Insights",
    "Integrated Data Ecosystem",
    "Secure and Compliant Cloud Strategies",
  ];

  const tabContent = [
    {
      heading: "Unified Cloud Excellence",
      subheading: "We bring together the power of Databricks, Snowflake, and Azure to create seamless, high-performance cloud data ecosystems tailored to your business.",
      image: cloudl1Tab,
    },
    {
      heading: "Scalable, Cost-Efficient Solutions",
      subheading: " Our cloud-native architectures optimize resource usage, ensuring your data infrastructure is both scalable and cost-effective as your needs grow.",
      image: cloudl2Tab,
    },
    {
      heading: "Lightning-Fast Insights",
      subheading: "Leveraging cutting-edge platforms, we design solutions that enable real-time data processing, analytics, and AI-driven insights at unparalleled speed.",
      image: cloudl3Tab,
    },
    {
      heading: "Integrated Data Ecosystem",
      subheading: "We specialize in connecting disparate systems and data sources into a unified platform, ensuring smooth workflows and actionable intelligence.",
      image: cloudl4Tab,
    },
    {
      heading: "Secure and Compliant Cloud Strategies",
      subheading: "Our expertise ensures that your cloud data solutions meet the highest standards of security, governance, and regulatory compliance, protecting your assets at every step.",
      image: cloudl5Tab,
    },
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}

          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${index === activeTab ? "active" : ""
            }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
           
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
              <Image
                src={tabContent[activeTab].image}
                alt={tabContent[activeTab].heading}
                width={457}
                height={257}
                className="productbanner_imageslider"
                loading="eager"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
